


























import { cloneDeep } from "lodash";
import { ValidationProvider } from 'vee-validate'
import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import ToggleButton from "../ToggleButton.vue";
import TypedChips from "../TypedChips/TypedChips.vue";
import { PossibleChipTypeInfo, RawChipItem } from "../TypedChips/typedChips.types";
import { BlackWhiteListItem, BlackWhiteListItemType } from './types'

@Component({
  components: {
    ToggleButton,
    TypedChips,
    ValidationProvider
  },
})
export default class TypedBlackWhiteList extends Vue {

  @VModel({ type: Object }) list!: BlackWhiteListItem<RawChipItem>

  @Prop({ type: Object, required: true }) possibleChipTypeInfos!: PossibleChipTypeInfo

  @Prop({ default: false }) draggable!: boolean

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop() validation!: string

  @Prop() prefix!: string

  onChange(value: Array<RawChipItem>) {
    const list = cloneDeep(this.list)

    list.items = value

    this.list = cloneDeep(list)
  }

  get listType(): boolean {
    return this.list.type === BlackWhiteListItemType.Whitelist
  }

  set listType(switchState: boolean) {
    const list = cloneDeep(this.list)

    list.type = switchState ? BlackWhiteListItemType.Whitelist : BlackWhiteListItemType.Blacklist

    this.list = cloneDeep(list)
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      black_white_list_radio_whitelist: 'Белый список',
      black_white_list_radio_blacklist: 'Черный список',
    })
    this.$i18n.mergeLocaleMessage('en', {
      black_white_list_radio_whitelist: 'White list',
      black_white_list_radio_blacklist: 'Black list',
    })
  }
}
